import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  makeStyles,
  CircularProgress
} from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/authContext';
import { Creators } from '../../../store/pmp/actions';
import { useSelector, useDispatch } from 'react-redux';
import Page from '../../../components/Page';
import { LoadingContainer } from './styles';
import Results from './Results';
import Toolbar from './Toolbar';
import data from './data';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const UserListView = () => {
  const [Users] = useState(data);
  const { userList, loading } = useSelector((state) => {
    return state.pmpReducer;
  });
  const { currentUser, userRole } = useAuth();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyles();
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [array, setArray] = useState(userList);

  useEffect(()  => {
    if (userRole !== 'admin') {
      navigate('/app/central');
    }
    const userId = currentUser.uid;
    const officeId = sessionStorage.getItem('office-id');
    const payload = { userId, officeId };
    dispatch(Creators.getUsers(payload));
    setLimit(10);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const paginate = (array, page_size, page_number) => {
    if (array) {
      return array.slice(page_number * page_size, page_number * page_size + page_size);
    }
    return [];
  };

  useEffect(() => {
    const arr = paginate(userList, limit, page);
    setArray(arr);
  },[page, limit]);

  useEffect(() => {
    const arr = paginate(userList, limit, page);
    setArray(arr);
  }, [userList])

  return (
    <Page
      className={classes.root}
      title="Usuários"
    >
      <Container maxWidth={false}>
        <Toolbar />
        <Box mt={3}>
          {loading ? 
            (
              <LoadingContainer>
                <CircularProgress />
              </LoadingContainer>
            )
            :
            (array && 
              <Results 
                Persons={array} 
                userId={currentUser.uid} 
                userRole={userRole}
                page={page}
                setPage={setPage}
                limit={limit}
                setLimit={setLimit}
                arrayLength={userList.length}
              />
            )
          }
        </Box>
      </Container>
    </Page>
  );
};

export default UserListView;
